export default {
  preview: {
    label: 'Vista previa',
    tooltip: 'Previsualiza la página de pedidos online en una pestaña nueva.',
  },
  buttons: {
    visit_online_store: 'Tienda en línea',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Error al abrir el portal de pedidos',
  },
};
